import { type FC } from 'react'
import { Box, type BoxProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { type SeverityType } from '@Types/severity'

import * as styles from './styles'

export type InfoMessageBottomCardProps = BoxProps & {
  severity: SeverityType
  isElevated?: boolean
  hasBottomBorderRadius?: boolean
  hasNoBorder?: boolean
}

const InfoMessageBottomCard: FC<InfoMessageBottomCardProps> = ({
  severity,
  children,
  isElevated = false,
  hasBottomBorderRadius = false,
  hasNoBorder = false,
  ...rest
}) => {
  const theme = useTheme()

  return (
    <Box
      {...rest}
      sx={styles.commonStyles(theme, hasBottomBorderRadius, !hasNoBorder, isElevated)}
      css={styles.container(theme, severity, hasBottomBorderRadius)}
    >
      {children}
    </Box>
  )
}

export default InfoMessageBottomCard
